import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from "@/utils/axios";
import VueScroll from "@david-j/vue-j-scroll";

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$http = axios;
Vue.use(VueScroll);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
